import type { FeatureModule, FeatureState } from '../types';

export default function createLinkHighlightModule(): FeatureModule {
  let enabled = false;
  const STYLE_ID = 'accessify-link-highlight';
  const STORAGE_KEY = 'accessify-link-highlight';

  function getStyles(): string {
    return `
      /* accessify link highlighting */
      a[href] {
        text-decoration: underline !important;
        text-decoration-thickness: 3px !important;
        text-underline-offset: 3px !important;
        text-decoration-color: #1a73e8 !important;
        background-color: rgba(26, 115, 232, 0.1) !important;
        padding: 2px 4px !important;
        border-radius: 2px !important;
        transition: background-color 0.15s ease !important;
      }

      a[href]:hover {
        background-color: rgba(26, 115, 232, 0.25) !important;
      }

      a[href]:visited {
        text-decoration-color: #681da8 !important;
        background-color: rgba(104, 29, 168, 0.1) !important;
      }

      a[href]:visited:hover {
        background-color: rgba(104, 29, 168, 0.25) !important;
      }

      /* External link indicator */
      a[href^="http"]:not([href*="${typeof window !== 'undefined' ? window.location.hostname : ''}"]):after {
        content: " \\2197";
        font-size: 0.8em;
        vertical-align: super;
      }
    `;
  }

  function injectStyles() {
    let styleEl = document.getElementById(STYLE_ID);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = STYLE_ID;
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = getStyles();
  }

  function removeStyles() {
    const styleEl = document.getElementById(STYLE_ID);
    styleEl?.remove();
  }

  function activate() {
    enabled = true;
    injectStyles();
    localStorage.setItem(STORAGE_KEY, 'true');
  }

  function deactivate() {
    enabled = false;
    removeStyles();
    localStorage.removeItem(STORAGE_KEY);
  }

  return {
    id: 'link-highlight',
    name: () => 'Link Highlight',
    description: 'Highlight all links with thick underlines and background colors',
    icon: 'link-highlight',
    category: 'visual',
    activate,
    deactivate,
    getState: (): FeatureState => ({
      id: 'link-highlight',
      enabled,
    }),
    setState: (state: { enabled: boolean }) => {
      if (state.enabled) {
        activate();
      } else {
        deactivate();
      }
    },
  };
}
